import { gql } from "@apollo/client";
const user = ` 
     _id
      name
      email
      role
      partnerId
      isActive
      createdAt
`;

const verificationData = `
status
message
`;

/**
 * PARTNER_LOGIN
 */
export const PARTNER_LOGIN = gql`
  mutation PARTNER_LOGIN($input: LoginPartnerInput!) {
    loginPartnerAuth(input: $input) {
      token
      userData {
         ${user}
      }
    }
  }
`;

/**
 * GET USER PROFILE
 */
export const PARTNER_USER_PROFILE = gql`
  query PARTNER_USER_PROFILE {
  partnerUserProfile {      
        ${user}
    }
  }
`;

/**
 * VERIFY_PARTNER
 */
export const VERIFY_PARTNER = gql`
  query VERIFY_PARTNER($input: PartnerVerifyInput!) {
  verifyPartner(verifyData: $input) {      
        ${verificationData}
    }
  }
`;
